export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.workbench.link': '工作台',
  'pages.workbench.alertMessage': '欢迎来到工作台',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.announcement.status.draft': '草稿',
  'pages.announcement.status.scheduled': '待定时发布',
  'pages.announcement.status.publishing': '发布中',
  'pages.announcement.status.published': '已发布',
  'pages.announcement.status.publish_failed': '发布失败',
  'pages.announcement.status.revoked': '已撤回',
  'pages.announcement.audience.memberLabel': '接收成员',
  'pages.announcement.audience.selectMembers': '请选择成员',
  'pages.announcement.fields.status': '状态',
  'pages.announcement.fields.publishTime': '发布时间',
  'pages.announcement.fields.audience': '投放范围',
  'pages.announcement.fields.summary': '摘要',
  'pages.announcement.fields.revokeReason': '撤回原因',
  'pages.announcement.fields.content': '公告正文',
  'pages.announcement.fields.attachments': '附件',
  'pages.announcement.admin.title': '公告管理',
  'pages.announcement.admin.columns.title': '公告标题',
  'pages.announcement.admin.columns.creator': '创建人',
  'pages.announcement.admin.columns.publishTimeRange': '发布时间范围',
  'pages.announcement.admin.columns.actions': '操作',
  'pages.announcement.admin.search.titlePlaceholder': '请输入标题关键词',
  'pages.announcement.admin.search.creatorPlaceholder': '请输入创建人',
  'pages.announcement.admin.pendingPublish': '待发布',
  'pages.announcement.admin.revokeReason': '后台手动撤回',
  'pages.announcement.admin.empty': '暂无公告，点击右上角新建第一条公告',
  'pages.announcement.admin.dispatchModalTitleWithName': '{title} 的发布记录',
  'pages.announcement.detail.title': '公告详情',
  'pages.announcement.detail.notFound': '公告不存在',
  'pages.announcement.detail.backToList': '返回列表',
  'pages.announcement.detail.edit': '编辑',
  'pages.announcement.detail.revoke': '撤回',
  'pages.announcement.detail.revokeReason': '详情页手动撤回',
  'pages.announcement.detail.revokeSuccess': '公告已撤回',
  'pages.announcement.detail.dispatchRecords': '发布记录',
  'pages.announcement.create.title': '新建公告',
  'pages.announcement.create.scheduleSuccess': '公告已设置定时发布',
  'pages.announcement.create.publishSuccess': '公告已提交发布',
  'pages.announcement.edit.title': '编辑公告',
  'pages.announcement.edit.updateSuccess': '公告已更新',
  'pages.announcement.form.statusReason': '当前公告存在状态说明',
  'pages.announcement.form.title': '公告标题',
  'pages.announcement.form.titlePlaceholder': '请输入公告标题',
  'pages.announcement.form.titleRequired': '请输入公告标题',
  'pages.announcement.form.summary': '公告摘要',
  'pages.announcement.form.summaryPlaceholder':
    '请输入摘要，前台卡片会优先展示摘要',
  'pages.announcement.form.content': '公告正文',
  'pages.announcement.form.contentPlaceholder': '请输入公告正文',
  'pages.announcement.form.contentRequired': '请输入公告正文',
  'pages.announcement.form.pinned': '置顶展示',
  'pages.announcement.form.pinnedOn': '置顶',
  'pages.announcement.form.pinnedOff': '普通',
  'pages.announcement.form.publishMode': '发布时间',
  'pages.announcement.form.publishModeRequired': '请选择发布时间类型',
  'pages.announcement.form.scheduledAt': '定时发布时间',
  'pages.announcement.form.scheduledAtRequired': '请选择定时发布时间',
  'pages.announcement.form.scheduledAtFuture': '定时发布时间必须晚于当前时间',
  'pages.announcement.form.audiences': '投放范围',
  'pages.announcement.form.audiencesRequired': '请至少添加一个投放范围',
  'pages.announcement.form.memberRequired': '请选择成员',
  'pages.announcement.form.saveDraft': '保存草稿',
  'pages.announcement.form.saveDraftSuccess': '草稿已保存',
  'pages.announcement.form.publishScheduled': '定时发布',
  'pages.announcement.form.publishNow': '立即发布',
  'pages.announcement.form.submitTip':
    '保存草稿不会触发消息中心。立即发布和定时发布都会按后端规则处理。',
  'pages.announcement.form.cancel': '取消',
  'pages.announcement.center.title': '公告中心',
  'pages.announcement.center.columns.title': '标题',
  'pages.announcement.center.columns.readStatus': '已读状态',
  'pages.announcement.center.columns.pinned': '是否置顶',
  'pages.announcement.center.columns.organization': '发布组织',
  'pages.announcement.center.columns.attachmentStatus': '附件状态',
  'pages.announcement.center.search.titlePlaceholder': '请输入标题关键词',
  'pages.announcement.center.read.read': '已读',
  'pages.announcement.center.read.unread': '未读',
  'pages.announcement.center.boolean.yes': '是',
  'pages.announcement.center.boolean.no': '否',
  'pages.announcement.center.boolean.none': '无',
  'pages.announcement.center.attachment.has': '含附件',
  'pages.announcement.center.attachment.none': '无附件',
  'pages.announcement.center.emptySummary': '暂无摘要',
  'pages.announcement.center.viewDetail': '查看详情',
  'pages.announcement.center.empty': '暂无可查看公告',
  'pages.announcement.center.detail.title': '公告详情',
  'pages.announcement.center.detail.backToCenter': '返回公告中心',
  'pages.announcement.center.detail.content': '正文',
  'pages.announcement.center.detail.loadFailed': '公告加载失败',
  'pages.announcement.center.detail.retry': '重试',
  'pages.announcement.permission.queryRequired': '当前账号没有查询权限',
  'pages.announcement.dispatch.columns.type': '发布方式',
  'pages.announcement.dispatch.columns.status': '消息中心状态',
  'pages.announcement.dispatch.columns.errorMessage': '失败原因',
  'pages.announcement.dispatch.columns.response': '返回摘要',
  'pages.announcement.dispatch.status.pending': '待派发',
  'pages.announcement.dispatch.status.processing': '处理中',
  'pages.announcement.dispatch.status.success': '成功',
  'pages.announcement.dispatch.status.failed': '失败',
  'pages.announcement.dispatch.malformedResponse': '历史返回摘要格式异常',
  'pages.announcement.dispatch.expand': '展开',
  'pages.announcement.attachment.uploadSuccess': '{name} 上传成功',
  'pages.announcement.attachment.uploadFailed': '附件上传失败，请重试',
  'pages.announcement.attachment.fileTooLarge': '单个附件不能超过 20MB',
  'pages.announcement.attachment.selectFiles': '选择附件',
  'pages.announcement.attachment.empty': '暂无附件',
  'pages.announcement.attachment.delete': '删除',
  'pages.announcement.attachment.retry': '重试',
  'pages.announcement.attachment.uploadCompleted': '上传完成',
  'pages.announcement.attachment.missingFileKey':
    '附件缺少文件标识，暂时无法下载',
  'pages.announcement.attachment.downloadUrlMissing': '后端未返回下载地址',
  'pages.announcement.attachment.downloadFailed': '获取下载地址失败',
  'pages.announcement.attachment.download': '下载',
};
